import { useSelector } from 'react-redux';
import selectTeams from 'redux-api/reselect/teams';

// Renders children only when the team member has access to the given section.
// Otherwise renders `fallback` (children are not mounted, so no API calls fire).
function ScopeGate({ section, children, fallback = null }) {
  const { canAccessSection } = useSelector(selectTeams);

  return canAccessSection(section) ? children : fallback;
}

export default ScopeGate;
